import { PropsWithChildren, useMemo } from 'react';
import { useTheme } from 'styled-components';
import { Heading } from '../heading';
import { ErrorText, Wrapper } from './styled';

export type FormFieldProps = PropsWithChildren<{
  as?: 'div' | 'label';
  label?: string;
  labelSize?: 'small' | 'medium' | 'big';
  required?: boolean;
  error?: string;
  hide?: boolean;
  intercomTarget?: string;
}>;

export function FormField({
  label,
  children,
  labelSize = 'small',
  required = false,
  error,
  intercomTarget,
  ...rest
}: FormFieldProps): JSX.Element {
  const theme = useTheme();

  const labelHeadingVariant = useMemo(() => {
    if (labelSize === 'medium') {
      return 'h5';
    }

    if (labelSize === 'big') {
      return 'h4';
    }

    return 'h6';
  }, [labelSize]);

  return (
    <Wrapper {...rest}>
      {typeof label === 'string' && (
        <Heading
          variant={labelHeadingVariant}
          style={{ marginBottom: theme.spacing_unit_x1 }}
          data-intercom-target={intercomTarget}
        >
          {label}
          {required === true && ' *'}
        </Heading>
      )}
      {children}
      {typeof error === 'string' && <ErrorText>{error}</ErrorText>}
    </Wrapper>
  );
}
